module.exports = __webpack_public_path__ + "static/media/spotting-OFF.c26f8264.png";